import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { TopicFlashcard, TopicEditState } from './types';

export type { TopicEditState };

const initialState: TopicEditState = {
  flashcards: [],
  isFlashcardsLoading: false,
  flashcardsError: null
};

export const slice = createSlice({
  name: 'topicEdit',
  initialState,
  reducers: {
    startFlashcardsLoading(state) {
      state.isFlashcardsLoading = true;
    },
    setFlashcards(state, action: PayloadAction<TopicFlashcard[]>) {
      state.flashcards = action.payload;
      state.isFlashcardsLoading = false;
    },
    addFlashcard(state, action: PayloadAction<TopicFlashcard>) {
      state.flashcards.push(action.payload);
    },
    updateFlashcard(state, action: PayloadAction<TopicFlashcard>) {
      const idx = state.flashcards.findIndex((c) => c.guid === action.payload.guid);
      if (idx !== -1) state.flashcards[idx] = action.payload;
    },
    removeFlashcard(state, action: PayloadAction<string>) {
      state.flashcards = state.flashcards.filter((c) => c.guid !== action.payload);
    },
    setFlashcardsError(state, action: PayloadAction<string>) {
      state.flashcardsError = action.payload;
      state.isFlashcardsLoading = false;
    },
    clearFlashcardsError(state) {
      state.flashcardsError = null;
    }
  }
});

export default slice.reducer;

export const { clearFlashcardsError } = slice.actions;
